import {
  TOGGLE_LOADING,
  FETCH_LIVE_CONVERSATION_LISTING,
  FETCH_LIVE_CHAT_LISTING,
  FETCH_TEAM_LISTING,
  FETCH_ASSIGN_LISTING,
  FETCH_LABEL_LISTING,
  LEAD_SELECTED_DATA,
  FETCH_CANNED_LISTING
} from "../../constants/LiveChatActionTypes";


  const initialState = {
    loading: false,
    live_chat_listing: null,
    live_bot_listing: null,
    team_list: null,
    assign_list: null,
    label_list: null,
    lead_select_data: null,
    canned_listing: null
  }

  const liveChatReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case TOGGLE_LOADING:
        return { ...state, loading: payload };
      case FETCH_LIVE_CONVERSATION_LISTING:
        return { ...state, live_chat_listing: payload };
      case FETCH_LIVE_CHAT_LISTING:
        return { ...state, live_bot_listing: payload };
      case FETCH_TEAM_LISTING:
        return { ...state, team_list: payload };
      case FETCH_ASSIGN_LISTING:
        return { ...state, assign_list: payload };
      case FETCH_LABEL_LISTING:
        return { ...state, label_list: payload };
      case LEAD_SELECTED_DATA:
        return { ...state, lead_select_data: payload };
      case FETCH_CANNED_LISTING:
        return { ...state, canned_listing: payload };
      default:
        return state;
    }
  };

  export default liveChatReducer;
